// extracted by mini-css-extract-plugin
export default {"banner_img":"terms-and-conditions_banner_img__BUe7H","hr":"terms-and-conditions_hr__59gH3"};